/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { batch } from 'react-redux';

import registrationApi from '../../../api/registrationApi';
import {
  markCurrentStepAsCompletedAndGoToNextStep,
  globalReset,
  divertProgress,
} from '../steps/actions';

import { showMainLoading, hideMainLoading } from '../main/actions';
import { updateDirectorList } from '../idverification/actions';
import { selectWorkflowActiveStepLinkByRel } from '../../../selectors';

import phoneNumberUtils from '../../../utils/phoneNumberUtils';
import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';

export const { saveMobile, updateErrorMessage } = createActions(
  actionTypes.SAVE_MOBILE,
  actionTypes.UPDATE_ERROR_MESSAGE,
  getActionOptions(ACTION_PREFIX),
);

export function saveMobileNumberAndGoToNextStep(mobileNumber) {
  return (dispatch, getState) => {
    const state = getState();
    const stepLink = selectWorkflowActiveStepLinkByRel(state, 'MobileSkipVerify');

    if (!stepLink) {
      dispatch(globalReset());
      return null;
    }

    dispatch(showMainLoading('Please wait...'));

    const formattedMobileNumber =
      phoneNumberUtils && mobileNumber && phoneNumberUtils.formatMobilePhoneNumber(mobileNumber);

    let shouldInvokeRegisterNext = false;
    return registrationApi
      .saveMobileNumberNoVerify(stepLink.href, formattedMobileNumber || '')
      .then((response) => {
        const { output } = response.data;
        const { isError, links, officeHolders } = output;

        batch(() => {
          dispatch(saveMobile({ mobileNumber }));
          dispatch(hideMainLoading());

          if (!isError && officeHolders && officeHolders.length) {
            dispatch(updateDirectorList(officeHolders));
          }

          if (!isError && links && links.length) {
            const link = links[0];
            if (link.rel === 'ThankYou') {
              batch(() => {
                const successMessage =
                  'Thank you for entering your details. We will call you shortly to complete your registration.';
                dispatch(
                  divertProgress({
                    isBlocked: false,
                    isSuccess: true,
                    message: successMessage,
                  }),
                );
              });
            } else if (link.rel === 'Register') {
              shouldInvokeRegisterNext = true;
            } else {
              dispatch(markCurrentStepAsCompletedAndGoToNextStep(links));
            }
          }
        });
        return { shouldInvokeRegisterNext, links };
      })
      .finally(() => dispatch(hideMainLoading()));
  };
}
